import { render } from "./external-data-confirm.vue?vue&type=template&id=a375ef24&scoped=true"
import script from "./external-data-confirm.vue?vue&type=script&lang=js"
export * from "./external-data-confirm.vue?vue&type=script&lang=js"

import "./external-data-confirm.vue?vue&type=style&index=0&id=a375ef24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a375ef24"]])

export default __exports__